import { type ForwardedRef, type PropsWithChildren, forwardRef } from "react";

import { Box } from "@aircall/tractor";
import { motion } from "framer-motion";

import { useAccordionItem } from "../../contexts/hooks/useAccordionItem";

import type { AccordionBodyProps } from ".";

/**
 * We do this to override framer's default transition
 * More info here: https://www.framer.com/motion/component/#%23transform
 */
function emptyTransformTemplate() {
  return "";
}

function AccordionBodyBase(
  { children, ...props }: PropsWithChildren<AccordionBodyProps>,
  ref: ForwardedRef<HTMLDivElement | null>
) {
  const { isOpened, id } = useAccordionItem();

  return (
    <Box
      overflow="hidden"
      data-test={`accordion-body-${id}`}
      ref={ref}
      {...props}
    >
      <motion.div
        layout
        initial={{
          height: isOpened ? "fit-content" : 0,
          opacity: isOpened ? 1 : 0,
          overflow: isOpened ? "initial" : "hidden",
        }}
        animate={{
          height: isOpened ? "fit-content" : 0,
          opacity: isOpened ? 1 : 0,
        }}
        transformTemplate={emptyTransformTemplate}
        style={{
          overflow: isOpened ? "initial" : "hidden",
          pointerEvents: isOpened ? "initial" : "none",
        }}
      >
        {children}
      </motion.div>
    </Box>
  );
}

export const AccordionBody = forwardRef(AccordionBodyBase);
